const weaponMasteries = {
  cleave: {
    label: 'Cleave',
    description:
      "If you hit a creature with a melee attack roll using this weapon, you can make a melee attack roll with the weapon against a second creature within 5 feet of the original target and within your reach. On a hit, the second creature takes the weapon's damage; don't add a positive ability modifier to this damage, but a negative modifier still applies. You can make this extra attack only once per turn.",
  },
  graze: {
    label: 'Graze',
    description:
      'If your attack roll with this weapon misses a creature, you can deal damage to that creature equal to the ability modifier you used to make the attack roll. This damage is the same type dealt by the weapon, and the damage can be increased only by increasing the ability modifier.',
  },
  nick: {
    label: 'Nick',
    description:
      'When you make the extra attack of the Light property with this weapon, you can make it as part of the Attack action instead of as a Bonus Action. You can still make this extra attack only once per turn.',
  },
  push: {
    label: 'Push',
    description:
      'If you hit a creature with this weapon, you can push the creature up to 10 feet straight away from yourself if it is Large or smaller.',
  },
  sap: {
    label: 'Sap',
    description:
      'If you hit a creature with this weapon, the creature has Disadvantage on the next attack roll it makes before the start of your next turn.',
  },
  slow: {
    label: 'Slow',
    description:
      'If you hit a creature with this weapon and deal damage to it, you can reduce its Speed by 10 feet until the start of your next turn. If the creature is hit more than once by weapons that have this property, the Speed reduction doesn’t exceed 10 feet.',
  },
  topple: {
    label: 'Topple',
    description:
      'If you hit a creature with this weapon, you can force it to make a Constitution saving throw (DC 8 plus the ability modifier used for the attack roll and your Proficiency Bonus). On a failed save, the creature has the Prone condition.',
  },
  vex: {
    label: 'Vex',
    description:
      'If you hit a creature with this weapon and deal damage to the creature, you have Advantage on the next attack roll you make against that creature before the end of your next turn.',
  },
};

export default weaponMasteries;
